import style2 from "./Cities.module.css";
import { useEvent, useStore } from 'effector-react';

import {
  $clusterInfoModal,
  $clusterSelect,
  resetClusterInfoModalEv,
} from '../../models/overviewModel/index.js';

import {
  Button,
  Modal,
  Table,
  Tooltip,
  Dropdown,
  Select,
  ConfigProvider,
  TreeSelect,
  Skeleton,
  Tabs,

} from 'antd';
import ProjectCreateEditForm from '../ProjectCreateEditForm/ProjectCreateEditForm.jsx';
import EditSteps from '../../pages/EditProject/EditSteps.jsx';
import React from 'react';
import MapModalComponent from './MapModalComponent.jsx';
import ProblemTableComponent from '../ProblemTableComponent/ProblemTableComponent.jsx';


const { TabPane } = Tabs;

function MapModal({ isOpen, setIsOpen, type }) {
  const clusterInfoModal = useStore($clusterInfoModal);
  const close = useEvent(resetClusterInfoModalEv);

  return (
    <Modal
      open={false}
      onCancel={close}
      width="80dvw"
      footer={[]}
      destroyOnClose
    >
      <MapModalComponent />
      {/*<ProblemTableComponent/>*/}





    </Modal>
  );
}

export default MapModal;
